import React from "react";
import { isEmpty } from "lodash";
import { IconList } from "@/components/IconList";
import classNames from "classnames";
import { Typography } from "@/components/Typography";
import { Icon_Facility } from "@/types/qr";
import "./PreviewFacilitiesCard.scss";

export interface PreviewFacilitiesCardProps {
  /** Array de facilities para mostrar */
  facilities?: Icon_Facility[];
  /** Título de la sección */
  title?: string;
  /** Variante de contexto */
  variant?: "business" | "event";
  /** Clase CSS adicional */
  className?: string;
}

/**
 * Tarjeta consolidada para Facilities/Services usada en Business y Event previews
 * Estandariza la presentación de facilities con título y lista de íconos
 */
export function PreviewFacilitiesCard({
  facilities,
  title,
  variant = "business",
  className,
}: PreviewFacilitiesCardProps) {
  if (!facilities || isEmpty(facilities)) {
    return null;
  }

  const cardClasses = classNames(
    "u-card",
    "preview-facilities-card",
    `preview-facilities-card--${variant}`,
    className
  );

  return (
    <div className={cardClasses}>
      {title && (
        <Typography
          Tag="p"
          size="m"
          classname="u-semibold"
        >
          {title}
        </Typography>
      )}
      <IconList
        compact
        items={facilities as unknown as string[]}
      />
    </div>
  );
}
